import React, { Component } from 'react';
import TransactionsBoard from './TransactionsBoard';
import ProjectsBoard from './ProjectsBoard';
import WalletsBoard from './WalletsBoard';

import '../Admin/Admin.css'
import Loader from '../Icons/Loader';

class Admin extends Component {

	state = {currentCategory:'projects'}

	componentDidMount() {
		this.setCurrentRoute();
	    this.props.actions.getProfile();
		this.props.actions.getAllTransactions();
		this.props.actions.getAllProjects();
		this.props.actions.getAllWallets();
	}

	setCurrentRoute(){
		this.props.actions.setCurrentRoute('Admin');
	}

	selectCategory(value){
		this.setState({
	    	currentCategory:value
	    })
	}

	render() {
		return (
			<div>
				<div className="container admin">
					<ul className="subMenu">
						<li className={this.state.currentCategory === 'projects' ? 'selected' : ''} onClick={() => this.selectCategory('projects')}>Projects</li>
						<li className={this.state.currentCategory === 'transactions' ? 'selected' : ''} onClick={() => this.selectCategory('transactions')}>Transactions</li>
						<li className={this.state.currentCategory === 'wallets' ? 'selected' : ''} onClick={() => this.selectCategory('wallets')}>Wallets</li>
					</ul>
					{(this.props.transactions === undefined || this.props.allprojects === undefined) &&
						<div className="adminBoard">
							<div className="loadingBloc"><Loader color="#000" /></div>
						</div>
					}
					{this.state.currentCategory === 'transactions' && (this.props.transactions && this.props.transactions.length > 0) &&
						<TransactionsBoard items={this.props.transactions} actions={this.props.actions} />
					}
					{this.state.currentCategory === 'projects' && (this.props.allprojects && this.props.allprojects.length > 0) &&
						<ProjectsBoard items={this.props.allprojects} actions={this.props.actions} />
					}
					{this.state.currentCategory === 'wallets' && (this.props.wallets && this.props.wallets.length > 0) &&
						<WalletsBoard items={this.props.wallets} actions={this.props.actions} />
					}
				</div> 
			</div>
		);
	}
}

export default Admin;



// WEBPACK FOOTER //
// ./src/components/Admin/Admin.js